import { Component } from '@theme/component';

class VariantRadios extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick.bind(this));
  }

  #handleClick(event) {
    const button = event.target.closest('[data-redirect-url]');
    if (!button) return;
    window.location.href = button.dataset.redirectUrl;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
